export default __webpack_public_path__ + "static/media/Img045.44b96844.jpg";